// VIS-267: the one meshopt decoder of the map (every GLTFLoader gets it from here). three's decoder unpacks a model's
// geometry on the main thread unless it is given workers; trees.glb, the units, the herds and the guests then held the
// page for a long task each while the map opened (on a phone: the loader's logo stalled). With one worker the unpacking
// leaves the main thread (GLTFLoader asks decodeGltfBufferAsync); one, not more: each worker keeps its own WASM heap
// (as large as the biggest buffer it unpacked) for the visit. The worker is a blob script that instantiates the WASM:
// worker-src blob: and 'wasm-unsafe-eval' (worker/headers.js), as the KTX2 transcoder's.
import { MeshoptDecoder } from 'three/addons/libs/meshopt_decoder.module.js';

if (typeof Worker === 'function') try { MeshoptDecoder.useWorkers(1); } catch (err) { console.warn('[meshopt] no worker: models unpack on the main thread', err); } // errors:ignore: three's main-thread decode is the fallback

export { MeshoptDecoder };
